import { render, staticRenderFns } from "./DefuncionesTemporales.vue?vue&type=template&id=039df964&"
import script from "./DefuncionesTemporales.vue?vue&type=script&lang=js&"
export * from "./DefuncionesTemporales.vue?vue&type=script&lang=js&"
import style0 from "./DefuncionesTemporales.vue?vue&type=style&index=0&id=039df964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports